export const beverage=[
    {
      "quantity":1,
      "id":68,
    "name":"Pepsi PET",
    "detail":"Pepsi PET",
    "price":57.14,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K350.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":69,
    "name":"Pepsi Can 300 ml",
    "detail":"Pepsi Can 300 ml",
    "price":57.14,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K485.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":70,
    "name":"7UP Can 320 ml",
    "detail":"7UP Can 320 ml",
    "price":57.14,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K487.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":71,
    "name":"Pepsi Black Can 370 ml",
    "detail":"Pepsi Black Can 370 ml",
    "price":57.14,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K486.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":72,
    "name":"Mirinda Can 340 ml",
    "detail":"Mirinda Can 340 ml",
    "price":57.14,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-K488.jpg?ver=20.85"
    }
    ]